import React, { useEffect, useState } from 'react';
import { Image, Result } from 'components/shared/AntComponent';
import Logo from 'assets/img/TVS-TS---Logo.png';
import ExamSubmitImg from 'assets/img/no-data.svg';
import SuccessImg from 'assets/icons/error.svg';
import { useDispatch } from 'react-redux';
import { submitExam2 } from 'services/store/actions/examAction';

const TestErrorPage: React.FC = () => {
    const dispatch = useDispatch();
    const storedGuestInfoData = localStorage.getItem('guestInfoData');
    const guestInfo = storedGuestInfoData ? JSON.parse(storedGuestInfoData) : null;
    const optionArr = localStorage?.getItem('selectedOptions');
    const selectedOptions = optionArr ? JSON.parse(optionArr) : null;
    const [showSuccessmsg, setShowSuccessmsg] = useState(true);
    const disableBackButton = () => {
        window.history.pushState(null, '', window.location.href);
        window.onpopstate = () => {
            window.history.go(1);
        };
    };
    const submitFailedExam = () => {
        const fdata: any = [];
        selectedOptions?.forEach((items: any) => {
            fdata.push({
                questionid: items.question_id,
                optionid: items.option_id,
                option_type: items.option_type
            });
        });

        // Prepare the payload for the API call
        const payload = {
            candidateid: guestInfo?.candidate_info?.id,
            examid: guestInfo?.exam_info?.id,
            questionpaperid: guestInfo?.exam_info?.associated_papers || "",
            duration: Number(guestInfo?.exam_info?.exam_duration) * 60 || "",
            examdata: fdata,
        };
        // Dispatch the examSubmit action
        dispatch(submitExam2(payload) as any);
    }
    useEffect(() => {
        if (guestInfo && showSuccessmsg) {
            submitFailedExam();
            setShowSuccessmsg(false);
        }
    }, [guestInfo, showSuccessmsg]);
    
    useEffect(() => {
        disableBackButton();
        return () => {
            window.onpopstate = null; // Cleanup to avoid memory leaks
        };
    }, []);

    return (
        <div className="test-success bg-guest">
            <div className="text-start ps-3 mb-3 pt-3">
                <Image src={Logo} alt="logo" width="auto" height="62px" preview={false} />
            </div>
            <div className="text-center h-100 my-auto d-flex align-items-center justify-content-center">

                <div className="row mx-0 ps-0 bg-white shadow-sm container align-items-center justify-content-center">
                    <div className="col ps-0 ">
                        <Image src={ExamSubmitImg} alt="exam-submit" width="auto" height="auto" preview={false} />
                    </div>
                    <div className="col-md-5 pe-5">
                        <div className="text-center me-4">
                            <Image src={SuccessImg} preview={false} height={60} className="text-center" />
                            <h3 className="text-danger fw-bold mt-3">Submission Failed</h3>
                            <h5 className="w- mx-auto mt-3 text-gray line-height">We &apos; re sorry, but we were unable to submit your exam due to a technical issue.
                            </h5>
                        </div>
                        <h6>
                        </h6>
                    </div>
                </div>
            </div>
            {/* <div className="text-center h-100 my-auto mt-5 pt-5">
                <Image src={Logo} alt="kovina" width="auto" height="62" preview={false} />
                <Result status="error" title="Your Test couldn't be submitted!" />
            </div> */}
        </div>
    );
};

export default TestErrorPage;
